/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_SOFTSKILL_ABILITY_USER } from "./actionTypes"
import {
  addSoftskillAbilityUserError,
  addSoftskillAbilityUserSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import { addSoftskillsAbilityUser } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(addSoftskillsAbilityUser, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (response.message) throw new Error(response.message)
    yield put(addSoftskillAbilityUserSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(addSoftskillAbilityUserError(error.message))
  }
}

function* softskillAbilityUserAddSaga() {
  yield takeEvery(ADD_SOFTSKILL_ABILITY_USER, add)
}

export default softskillAbilityUserAddSaga
